export default __webpack_public_path__ + "3a717deea8daeb9543e4c7e53e129aec.svg";